
const bmTree = {
  state: {
    bmTreeState: false,
    bmTreeIsRole: false,  // 是否根据权限
    bmTreeBranchId: '',
    bmTreeBranchName: '',

    bmTreeType: '',  // 部门树 类型，部门/科目

    bmTreeSelect: '',  // 选中的行数据

    bmTreeQuery: '',  // 参数json
  },

  mutations: {
    SET_BMTREESTATE: (state, bmTreeState) => {
      state.bmTreeState = bmTreeState
    },
    SET_BMTREEISROLE: (state, val) => {
      state.bmTreeIsRole = val
    },
    SET_BMTREEBRANCHID: (state, bmTreeBranchId) => {
      state.bmTreeBranchId = bmTreeBranchId
    },
    SET_BMTREEBRANCHNAME: (state, bmTreeBranchName) => {
      state.bmTreeBranchName = bmTreeBranchName
    },
    SET_BMTREE_SELECT: (state, val) => {
      state.bmTreeSelect = val
    },
    

    SET_BMTREE_TYPE: (state, bmTreeType) => {
      state.bmTreeType = bmTreeType
    },
    SET_BMTREE_QUERY: (state, val) => {
      state.bmTreeQuery = val
    },

  },

  actions: {
    
  }
}

export default bmTree
